import { TextOverflow } from "utils/common";
import StatusColumn from 'widgets/grid/cells/StatusColumn';
import { DateColumn } from "widgets/grid/cells/DateColumn";

export const CREATIVE_APPROVAL_COLUMNS = [
	/*
		The `key` names here are significant because they map to internal fields that the API uses
		for the `sort` parameter, case-sensitive, as it doesn't currently support sorting by nested
		object properties (The data from the endpoint has a nested `creative` and `user` object).
	*/
	{
		key: "creativeName",
		name: "Creative Name",
		width: 208,
		resizable: true,
		formatter: TextOverflow,
		sortable: true,
	},
	{
		key: "creativeId",
		name: "ID",
		width: 75,
		sortable: true,
	},
	{
		key: "name",
		name: "Status",
		width: 130,
		formatter: StatusColumn,
		sortable: true,
	},
	{
		key: "dateCreated",
		name: "Date",
		width: 137,
		formatter: DateColumn,
		sortable: true,
	},
	{
		key: "username",
		name: "User",
		width: 125,
		resizable: true,
		formatter: TextOverflow,
		sortable: true,
	},
	{
		key: "notes",
		name: "Notes",
		resizable: true,
		formatter: TextOverflow,
		sortable: true,
	},
];
